import { createApp } from "vue";
import moment from 'moment';
import App from "./App.vue";
import router from "./router/index.js";
import store from "./store/index.js";
import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap';
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./assets/styles.css";
import 'v-calendar/style.css';
import 'vue3-audio-player/dist/style.css';
import { Toasted } from "vue-toasted";
import { tooltip } from "../public/js/tooltip";
import CKEditor from '@ckeditor/ckeditor5-vue';
import 'ckeditor5/ckeditor5.css';
import VueTheMask from 'vue-the-mask';
import { MaskInput } from 'vue-3-mask';
import VCalendar from 'v-calendar';
import { createVuetify } from 'vuetify';
import { VColorPicker } from 'vuetify/components';
const app = createApp(App);
const vuetify = createVuetify({
    components: {
        VColorPicker
    }
});
app.config.globalProperties.$filters = {
    formatDate(value) {
        if (value) {
            return moment(String(value)).format('DD-MM-YYYY hh:mm:ss');
        }
    }
};
app.component('MaskInput', MaskInput);
app.use(router)
    .use(store)
    .use(CKEditor)
    .use(VCalendar, {})
    .use(Toasted, {
    iconPack: "fontawesome",
})
    .use(vuetify)
    .use(VueTheMask)
    .mount("#app");
app.directive('tooltip', tooltip);
